import { lazy } from 'react';

import { withCampaignSavedData } from './withCampaignSavedData';

const FormPagesStep05 = lazy(() => import('@features/campaigns/builder/containers/FormPages/Step05/Step05.tsx'));

export const EnhancedFormPagesStep05 = withCampaignSavedData(FormPagesStep05);
